import { render, staticRenderFns } from "./MyLiteFormDesigntime.vue?vue&type=template&id=1d061d68&scoped=true&"
import script from "./MyLiteFormDesigntime.vue?vue&type=script&lang=js&"
export * from "./MyLiteFormDesigntime.vue?vue&type=script&lang=js&"
import style0 from "./MyLiteFormDesigntime.vue?vue&type=style&index=0&id=1d061d68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d061d68",
  null
  
)

export default component.exports